import { consumeArchiveUndo } from 'app/lib/channel-archive-undo';
import { withErrorBoundary } from 'app/components/error-boundary';
import Responsive from 'app/components/responsive';
import { ToastProvider } from 'app/components/toast-provider';
import { withDashboardLayout } from 'app/hooks/with-dashboard-layout';
import { useNavigation, useRoute } from 'app/hooks/navigation';
import { useUnArchiveChannel } from 'app/network/chat/channel';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Toast from 'react-native-toast-message';
import { AllChannelsScreenComponent } from './components/all-channels';

const AllChannelsRouteComponent: NavigationScreen<'all-channels'> = () => {
  const route = useRoute<'all-channels'>();
  const navigation = useNavigation<'all-channels'>();
  const { t } = useTranslation('one-channel');
  const { mutate: unarchiveChannel } = useUnArchiveChannel();

  useEffect(() => {
    const archivedConvoChannelUrl = route.params?.archivedConvoChannelUrl;

    if (typeof archivedConvoChannelUrl === 'string' && consumeArchiveUndo(archivedConvoChannelUrl)) {
      Toast.show({
        type: 'success',
        position: 'bottom',
        bottomOffset: 48,
        text1: t('archivedConfirmation', { ns: 'all-channels' }),
        text2: t('archivedUndo', { ns: 'all-channels' }),
        visibilityTime: 15000,
        onPress: () => {
          unarchiveChannel(archivedConvoChannelUrl);
          Toast.hide();
        },
      });

      navigation.setParams({ archivedConvoChannelUrl: undefined });
    }
  }, [navigation, route.params?.archivedConvoChannelUrl, t, unarchiveChannel]);

  return (
    <>
      <Responsive mobile={<AllChannelsScreenComponent />} desktop={null} />
      <ToastProvider />
    </>
  );
};

export const AllChannelsScreen: NavigationScreen<'all-channels'> = withOptionalMetrics(
  'AllChannelsScreen',
  withErrorBoundary(withDashboardLayout(AllChannelsRouteComponent, 'chat')),
);
